// extracted by mini-css-extract-plugin
module.exports = {"heading":"styles_heading__vuXMY","heading__rule":"styles_heading__rule__kAhA2","pulse":"styles_pulse__jBjDn","jump":"styles_jump__xdZlT","wiggle":"styles_wiggle__nV3Jn"};